"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var genericKeyboard_sidecar_1 = require("@crokinole/to-engine/genericKeyboard-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
// import { diveKeyboard } from '@voyage/input/diveKeyboard-sidecar'
var _mx = 0;
var _my = 0;
var _sx = 0;
var _sy = 0;
function update(obj) {
    // if (clickEater.isCursorEaten()) {
    //   return
    // }
    var dt = common_sidecar_1.common.getUpdateDelta();
    var speed = 1500;
    var dirX = 0;
    var dirY = 0;
    var keys = genericKeyboard_sidecar_1.genericKeyboard.getKeys();
    if (keys.cameraLeft) {
        dirX -= speed;
    }
    if (keys.cameraRight) {
        dirX += speed;
    }
    if (keys.cameraUp) {
        dirY -= speed;
    }
    if (keys.cameraDown) {
        dirY += speed;
    }
    voyageCamera_sidecar_1.voyageCamera.setCameraXY(obj.cameraX + dirX * dt, obj.cameraY + dirY * dt);
}
exports.update = update;
